<template v-if="materialsData">
		<div v-for="material in materialsData" :key="material.id" class="material-info">
			<p class="name mb-2">
				<span v-if="material.material.acronym">({{material.material.acronym }}) - </span>{{ material.material.name }}
			</p>
			<p class="mb-4 text-sm italic text-neutral-400" v-if="material.material.description">{{ material.material.description }}</p>
			<div class="flex items-center justify-between flex-wrap">
				<div class="w-full">
					<p class="label">Class</p>
					<p class="value">{{ material.material.className }} </p>
				</div>
				<div class="w-full" v-if="material.material.category">
					<p class="label">Category</p>
					<p class="value"> {{ material.material.category }}</p>
				</div>
				<div class="w-1/2" v-if="material.material.productionCapacity">
					<p class="label">Production Capacity</p>
					<p class="value">
						{{ material.material.productionCapacity }} 
						<span class="lowercase" v-if="material.material.productionCapacityUnit">{{material.material.productionCapacityUnit.abbreviation }}</span>
					</p>
				</div>
				<div class="w-1/2" v-if="material.material.price">
					<p class="label">Price</p>
					<p class="value">
						{{ material.material.price }} 
						<span class="lowercase" v-if="material.material.priceUnit">{{ material.material.priceUnit.abbreviation }}</span>
					</p>
				</div>
				<div v-if="material.material.sustainabilityType" class="w-full">
					<p class="label">Sustainability Type</p>
					<p class="value">{{ material.material.sustainabilityType.name }}</p>
				</div>
				<div class="w-1/2">
					<p class="label">FDA Approved</p>
					<p class="value" v-if="material.material.isFdaApprovedFcm">{{ material.material.isFdaApprovedFcm }}</p>
					<p class="value" v-else>Unknown</p>
				</div>
			</div>
			<div v-if="material.material.sourcing">
				<p class="label">Sourcing</p>
				<p v-for="(source, key) in material.material.sourcing" :key="key">
					{{ source }}
				</p>
			</div>
			<AssetMaterialProperties :asset-material="material" />
		</div>
	
</template>
<script setup lang="ts">

import { AssetMaterialInterface } from '@/models/assetAssessmentInterfaces';
import AssetMaterialProperties from './AssetMaterialProperties.vue';
import { defineProps } from 'vue';

defineProps<{
	materialsData: AssetMaterialInterface[]; 
}>()

</script>

